import { css, jsx } from '@emotion/react';
import { Typography, Colors } from '@zapier/design-system';

const ModalDialogBodyStyles = ({ textAlign }) => css(Object.assign(Object.assign({}, Typography.Body1), { display: "flex", minHeight: 0, position: "relative", marginBottom: "var(--zds-space-20, 20px)", color: `var(--zds-text-default, ${Colors.GrayWarm10})`, textAlign, "::-webkit-scrollbar": {
  WebkitAppearance: "none",
  width: "var(--zds-size-8, 7px)"
}, "::-webkit-scrollbar-thumb": {
  borderRadius: "var(--zds-radius-small, 4px)",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  boxShadow: "0 0 1px rgba(255, 255, 255, 0.5)"
}, "::-webkit-scrollbar-thumb:hover": {
  backgroundColor: "#555"
}, "&::after": {
  content: "''",
  position: "absolute",
  bottom: "-1px",
  left: 0,
  right: 0,
  height: "46px",
  pointerEvents: "none",
  background: "linear-gradient(0deg, #fffdf9 0%, #fff0 75%)"
} }));
const ModalDialogBodyInnerStyles = css({
  overflowY: "auto",
  paddingBottom: "26px"
});
const ModalDialogBody = ({ children, textAlign = "start" }) => {
  return jsx(
    "div",
    { css: ModalDialogBodyStyles({ textAlign }), "data-zds": true },
    jsx("div", { css: ModalDialogBodyInnerStyles, "data-zds": true }, children)
  );
};

export { ModalDialogBody };
//# sourceMappingURL=Body.es.js.map
